export class PaymentTypes {
    static WITHOUT_PAYMENT = 'without'
    static CASHLESS = 'cashless'
    static CASH = 'cash'
}
